import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Name from './Name'
import Flag, { StyledFlag } from '../../general/Flag'

const PlayerName = ({ country, fullName, name, needsApproval, username }) => (
	<StyledPlayerName>
		{country && <Flag country={country} />}
		<Inner>
			{name || username}
			{fullName && fullName !== name && <FullName>{fullName}</FullName>}
		</Inner>
		{needsApproval && <NeedsApproval>(nicht freigeschaltet)</NeedsApproval>}
	</StyledPlayerName>
)

PlayerName.propTypes = {
	country: PropTypes.string,
	fullName: PropTypes.string,
	name: PropTypes.string,
	needsApproval: PropTypes.bool,
	username: PropTypes.string
}

PlayerName.defaultProps = {
	country: null,
	fullName: null,
	name: null,
	needsApproval: false,
	username: null
}

const StyledPlayerName = styled(Name)`
	align-items: center;
	display: flex;

	${StyledFlag} {
		margin-right: 0 !important;
	}
`

const Inner = styled.div`
	display: flex;
	flex-direction: column;
`

const FullName = styled.div`
	color: ${props => props.theme.textLight};
	font-size: 0.6em;
	margin-top: 0.35rem;
`

const NeedsApproval = styled.span`
	color: ${props => props.theme.textLight};
`

export default PlayerName
